import Swiper from 'swiper11';
import 'swiper11/css/bundle';

import {getBosResizeUrl, getLocation} from '../../utils';

import {addPvNew, isAndroid} from '../../../../utils';
import {addImgUrlParams} from '../../bury';
import likeAnimation from '../likeAnimation.vue';
import {openUrlByOpenApi} from '@baidu/map-fe-utils';

import {mapGetters} from 'vuex';

export default {
    props: {
        imgListOrigin: {
            type: Array,
            default: []
        },
        // 埋点来源
        tpFrom: {
            type: String,
            default: ''
        },
        levelTwo: {
            type: String,
            default: ''
        },
        levelOne: {
            type: String,
            default: ''
        },
        subSource: {
            type: String,
            default: ''
        },
        // 拿到预加载图片高度
        preImgHeight: {
            type: Number,
            default: 0
        },
        source: {
            type: String,
            default: ''
        },
        noteStyle: {
            type: String,
            default: ''
        },
        unique_id: {
            type: String,
            default: ''
        },
        // 端外分享打开，顶部存在poi信息展示的情况下，轮播图容器按照1:1比例展示
        isSquare: {
            type: Boolean,
            default: false
        },
        dataIndex: {
            type: Number,
            default: 0
        },
        newBtnIcon: {
            type: Boolean,
            default: false
        }
    },
    components: {
        likeAnimation
    },
    data() {
        return {
            // swiper配置项
            swiperOption: {
                speed: 300,
                // loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true
                }
            },
            swiper_index: 1,
            // 获取第一个元素原始宽高
            swiperImg0: {
                width: 0,
                height: 0
            },
            // 最大浏览图片的index值
            viewMaxIndex: 0,
            swiperHeight: 'auto',
            // 可视区第一个index值
            firstShowIndex: 0,
            lastShowIndex: 0,
            leftMove: 0,
            maxIndex: 0,
            clickCount: 0,
            timer: null,
            likeClientX: 0,
            likeClientY: 0,
            currentIndex: null,
            likeAnmStatus: false,
            currSwiper: null,
            defaultImg: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/micro-default-img.png',
            defaultImgDark: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/micro-default-img-dark.png',
            iconUrl: 'https://map-mobile-lbsapp.cdn.bcebos.com/zhankai.png',
            imgList: [],
            showHighBg: false,
            showLowImg: true,
            // 是否显示缩略图，默认显示，第一张图渲染完隐藏
            showBgImg: true,
            // 动画是否在播放
            clickAniRuning: false
        };
    },
    computed: {
        ...mapGetters([
            'firstLowImg'
        ]),
        ...mapGetters('dataList', [
            'firstFeedFinish',
            'requestTime'
        ]),
        ...mapGetters('url', [
            'abtest',
            'uid'
        ]),
        bgLowImg() {
            // 第一张图片的缩略图做背景
            const imgSrc = this.imgListOrigin[0]?.src || '';
            const pic = getBosResizeUrl({src: imgSrc, width: 200, height: 200, focus: true});
            return pic;
        },
        backgroundStyle() {
            if (this.dataIndex === 0 && this.firstLowImg && this.showLowImg) {
            // 预加载场景有所缩略图时
                return {
                    'background-image': `url(${this.firstLowImg})`
                };
            }
            else if (this.dataIndex <= 1 && this.showBgImg) {
                // 没有预加载的缩略图时，前两篇默认使用第一张图做缩略图
                const {width = 0, height = 0} = this.imgListOrigin[0];
                const winWidth = window.innerWidth;
                const imgHeight = Math.max(Math.floor(winWidth * (height / width)), this.swiperHeight);
                return {
                    height: `${imgHeight}px`,
                    'background-image': `url(${this.bgLowImg})`
                };
            }
            return {};
        },
        swiperLowClass() {
            return {
                'low-bg': this.firstLowImg && this.showLowImg
            };
        },
        swiperConHeight() {
            if (this.dataIndex === 0) {
                return this.preImgHeight || this.swiperHeight;
            }
            return this.swiperHeight;
        },
        preLoadIndex() {
            return this.maxIndex + 3;
        },
        // 轮播图高度由首张图宽高决定
        imgSrc() {
            if (this.imgList && this.imgList[0]) {
                const {height = 0, src = '', width = 0} = this.imgList[0];
                if (height === 0 || width === 0) {
                    return src;
                }
                this.imageHeightHandle(width, height);
                const url = getBosResizeUrl({
                    src,
                    height: parseInt(this.swiperHeight, 10),
                    quality: 100
                });
                return url;
            }
        },
        jumpIconShow() {
            if (this.imgList && this.imgList.length) {
                const currentItem = this.imgList[this.swiper_index - 1];
                return currentItem && currentItem.jump_url;
            }
            return false;
        }
    },
    mounted() {
        const className = '.swiper-con-' + this.dataIndex;
        this.currSwiper = new Swiper(className, {
            // 设置方向，水平方向(horizontal)或垂直方向(vertical)
            direction: 'horizontal',
            on: {
                slideChange: val => {
                    this.onSlideChange(val);
                }
            }
        });
        this.$nextTick(() => {
            if (this.imgList && this.imgList[0]) {
                const {height = 0, width = 0} = this.imgList[0];
                if (height === 0 || width === 0) {
                    // 获取第一个元素用于设置swiper高度
                    this.getImageSize(this.imgList[0].src).then(res => {
                        const {width = 0, height = 0} = res || {};
                        this.imageHeightHandle(width, height);
                    });
                }
            }
        });
        this.lastShowIndex = Math.min(4, this.imgList.length - 1);
        this.$bus.$on('like-anm-status', this.likeAnmStatusHandle);
        this.lowImgLoad();
    },
    beforeDestroy() {
        this.$bus.$off('like-anm-status', this.likeAnmStatusHandle);
    },
    methods: {
        handleError(event) {
            const img = event.target;
            const isDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
            img.src = isDark ? this.defaultImgDark : this.defaultImg; // 假设defaultImg是组件的data属性
            img.classList.add('broken-image');
        },
        imageHeightHandle(width, height) {
            const winWidth = window.innerWidth;
            if (this.isSquare) {
                this.swiperHeight = winWidth;
            }
            else if ((width / height) <= 3 / 4) {
                this.swiperHeight = 6 * winWidth / 5;
            }
            else if ((width / height) >= 4 / 3) {
                this.swiperHeight = 3 * winWidth / 4;
            }
            else {
                // 3/4和4/3中间，盒子是自适应
                this.swiperHeight = winWidth * height / width;
            }
        },
        // 获取图像原始宽高
        getImageSize(url) {
            return new Promise(resolve => {
                let img = document.createElement('img');
                img.src = url;
                img.onload = () => {
                    // onload-加载完之后才能获取到图片宽高
                    resolve({width: img.naturalWidth, height: img.naturalHeight});
                };
            });
        },
        onSlideChange(swiperInstance) {
            const {realIndex} = swiperInstance || {};
            this.maxIndex = Math.max(realIndex, this.maxIndex);
            if (realIndex > this.viewMaxIndex) {
                this.$emit('view-img', realIndex + 1);
            }
            const obj = {
                levelOne: this.levelOne || '',
                levelTwo: this.levelTwo || '',
                tp: this.tpFrom,
                pmgc: this.subSource,
                source: this.source || 'feed',
                note_style: this.noteStyle,
                unique_id: this.unique_id,
                uid: this.uid || '',
                note_index: this.dataIndex,
                user_behavior_sessionid: this.requestTime,
                abtest: this.abtest || ''
            };
            this.$emit('swiper-bury', obj);
            this.$emit('swiper-slide-change');
            this.viewMaxIndex = Math.max(this.viewMaxIndex, realIndex);
            this.$nextTick(() => {
                this.swiper_index = realIndex + 1;
                if ((realIndex === this.lastShowIndex) && (this.lastShowIndex + 1 < this.imgList.length)) {
                    // 左滑
                    this.leftMove -= 8.5;
                    this.$refs.pointsContainer.style.transform
                        = 'translateX(' + (this.leftMove) + 'px)';
                    this.firstShowIndex++;
                    this.lastShowIndex++;
                }
                if ((realIndex === this.firstShowIndex) && this.firstShowIndex > 0) {
                    // 右滑
                    this.leftMove += 8.5;
                    this.$refs.pointsContainer.style.transform
                        = 'translateX(' + (this.leftMove) + 'px)';
                    this.firstShowIndex--;
                    this.lastShowIndex--;
                }
            });
        },
        handleContentClick(e) {
            // 清除定时器
            clearTimeout(this.timer);
            this.timer = null;
            if (this.clickAniRuning) {
                this.clickCount = 0;
                return;
            }
            this.currentIndex = '';
            const clickCountTimer = setTimeout(() => {
                this.clickCount = 0;
                clearTimeout(clickCountTimer);
            }, 500);
            // 点击计数加1
            this.clickCount++;
            if (this.clickCount === 1) {
                // 如果点击一次，并且300毫秒内没有再次点击，则执行单击事件
                this.timer = setTimeout(() => {
                    // 单击事件
                    this.clickCount = 0;
                    const {jump_url = ''} = this.imgList[this.swiper_index - 1] || {};
                    if (jump_url) {
                        openUrlByOpenApi(jump_url);
                        const typeMap = {
                            'uigc_park': 'park',
                            'uigc_trip': 'travel',
                            'uigc_traffic': 'people'
                        };
                        addPvNew(['PoiDPG.NewTravelPage.photo.click'], {
                            source: this.source,
                            content_type: typeMap[this.subSource] || ''
                        });
                    }
                }, 300); // 设置延迟时间
            }
            else if (this.clickCount === 2) {
                // 双击事件
                this.$emit('dbl-click', this.dataIndex);
                this.likeClientX = e.layerX;
                this.likeClientY = e.layerY;
                this.currentIndex = this.dataIndex;
            }
        },
        likeAnmStatusHandle(status) {
            this.likeAnmStatus = status;
            // 动画是否在播放(1000表示动画播放时长跟likeAnimation组件播放时长一致)
            this.clickAniRuning = status;
            if (status) {
                const timer = setTimeout(() => {
                    this.clickAniRuning = false;
                    this.currentIndex = '';
                    clearTimeout(timer);
                }, 1000);
            }
        },
        // 如果有缩略图，缩略图加载完成后发送首屏埋点。
        lowImgLoad() {
            if (this.firstLowImg) {
                const img = document.createElement('img');
                img.src = this.firstLowImg;
                img.onload = () => {
                    this.imgRenderStat();
                };
            }
        },
        handleImgLoad() {
            // 第一张图渲染完，隐藏缩略图
            this.showBgImg = false;
            if (this.firstLowImg) {
                return;
            }
            // 如果没有缩略图，高清图渲染完成后发送首屏渲染埋点
            this.imgRenderStat();
        },
        imgRenderStat() {
            if (this.dataIndex === 0) {
                // image渲染结束,渲染耗时
                const endTime = Date.now();
                // this.preImgHeight > 0 表示图片预加载
                const isPreLoad = this.preImgHeight > 0;
                this.$emit('img-render', endTime, isPreLoad);
            }
        },
        setImgList(imgVal) {
            // 图片链接修改，增加耗时统计属性
            this.imgList = addImgUrlParams(imgVal);
            // 首屏高清图片加载完成后，设置首屏高清图片
            if (this.dataIndex === 0 && this.firstLowImg) {
                const img = document.createElement('img');
                img.src = this.imgListOrigin[0].src;
                img.onload = () => {
                    this.imgList[0].src = img.src;
                    this.showHighBg = true;
                    this.showLowImg = false;
                };
            }
        }
    },
    watch: {
        imgListOrigin: {
            immediate: true,
            handler(val) {
                this.setImgList(val);
            }
        },
        imgList() {
            this.$nextTick(() => {
                // 预加载会改变数组长度，swiper默认不监听变更，无法左右滑动，需要手动执行update
                this.currSwiper.update();
            });
            this.lastShowIndex = Math.min(4, this.imgList.length - 1);
        }
    }
};
